import React from 'react';
import DUI from 'dui';
import { Route } from 'react-router-dom';

import { Provider } from 'react-redux'
import configureStore from './store';
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from 'history';
// import './typings/globals.d.ts'

const history = createBrowserHistory({
    basename: '/' + process.env.REACT_APP_BASENAME
});
const store = configureStore({}, history);

const { SocialLoginHeader } = DUI.Components;

type MainProps = {
    comp: React.ComponentType
}
const Main: React.FC<MainProps> = (props) => {
    return (
        <Provider store={store}>
            <SocialLoginHeader />
            <ConnectedRouter history={history}>
                <Route path="/" component={props.comp} key="index" />
            </ConnectedRouter>
        </Provider>
    )
};

export default Main;
